import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { TableWidgetComponentFactory } from '~/components/MyWorkspace/TableWidget';
import {
  MyPerformanceWidgetTableRow,
  useMyPerformanceWidget,
} from '~/scenes/MyWorkspace/components/Widgets/components/MyPerformanceWidget/useMyPerformanceWidget';

import { WidgetProps } from '../../data/widgets';

import { MyPerformance } from './components/MyPerformance/component';
import { TableHeader } from './components/TableHeader';

export interface MyPerformanceWidgetProps extends WidgetProps {}

const MyPerformanceWidgetComponent = TableWidgetComponentFactory({
  TableRowComponent: MyPerformance,
  getIdentifier: (item: MyPerformanceWidgetTableRow) => `${item.id}`,
  TableHeaderComponent: TableHeader,
  dataCy: 'my-performance-widget',
  allTableDialogProps: {
    maxWidth: 'lg',
    fullWidth: true,
  },
});

export const MyPerformanceWidget: React.FC<MyPerformanceWidgetProps> = ({
  title,
}) => {
  const { t } = useTranslation();

  const { tableRows, loading, failedToLoad, isTabDisabled } =
    useMyPerformanceWidget();

  return (
    <MyPerformanceWidgetComponent
      title={title || t('myPerformance')}
      data={tableRows}
      loading={loading}
      failedToLoad={failedToLoad}
      noDataMessage={t('noPerformance')}
      isTabDisabled={isTabDisabled}
    />
  );
};
